// external
import { MutationPayload, Store } from 'vuex';

// interfaces
import { 
    IReporter,
    IReportingEvent,
} from '@andromeda/telemetry-data-access-orion';
import {
    GET_REPORTERS,
    GET_REPORT_QUEUE,
    SEND_REPORT,
} from '../types';
import { IRootState } from '../mxr-store/state';

const emptyReportQueue = (store: Store<IRootState>) => {
    const queue: IReportingEvent[] = store.getters[GET_REPORT_QUEUE];
    const reporters: IReporter[] = store.getters[GET_REPORTERS];

    while (queue.length > 0) {
        const event: IReportingEvent = queue.shift()!;
        reporters.forEach(reporter => reporter.sendReport(event));
    }
};

const ReportingPlugin = (store: Store<IRootState>) => {
    store.subscribe((mutation: MutationPayload) => {
        switch (mutation.type) {
        case SEND_REPORT:
            emptyReportQueue(store);
            break;
        default:
            break;
        }
    });
};

export default ReportingPlugin;
